export default [
    {
        path: "calendars",
        name: "Lịch công tác",
        redirect: "/calendars/calendarbyday",
        component: {
            render(c) {
                return c("router-view");
            },
        },
        children: [
            {
                path: "calendarbyday",
                name: "Lịch công tác theo ngày",
                component: () =>
                    import(
                        "@/views/screens/calendars/CalendarByDay"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Lịch công tác"
                },
            },
            {
                path: "invitation_letter",
                name: "Danh sách giấy mời",
                component: () =>
                    import(
                        "@/views/screens/calendars/InvitationLetters"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Danh sách giấy mời"
                },
            },
            {
                path: "quick_document",
                name: "Danh sách văn bản",
                component: () =>
                    import(
                        "@/views/screens/calendars/QuickDocuments"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Danh sách văn bản"
                },
            },
            {
                path: "report_invitation_letter",
                name: "Báo cáo tổng hợp giấy mời",
                component: () =>
                    import(
                        "@/views/screens/calendars/ReportInvitationLetters"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Báo cáo tổng hợp giấy mời"
                },
            },
            {
                path: "report_quick_document",
                name: "Báo cáo tổng hợp văn bản",
                component: () =>
                    import(
                        "@/views/screens/calendars/ReportQuickDocuments"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Báo cáo tổng hợp văn bản"
                },
            },
            {
                path: "report_job_ubnd",
                name: "Báo cáo giao việc từ UBND",
                component: () =>
                    import(
                        "@/views/screens/calendars/ReportJobUBND"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Báo cáo giao việc từ UBND"
                },
            },
        ],
    }
]